<template>
  <MobilityReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="Mobility Report" title="Mobility Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import MobilityReport from "../staffadmin/MobilityReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewMobilityReport)
);
</script>
